import { Body1 } from '@cian/ui-kit';
import React from 'react';

import { NBSP } from 'shared/common/constants';

import { programGuideImages } from '../mortgage-assets';
import styles from './styles.css';

export interface IProgramGuidePage {
  title: string;
  image: {
    light: string;
    dark: string;
  };
  description: React.ReactNode;
}

export const PROGRAM_GUIDE_PAGES: IProgramGuidePage[] = [
  {
    title: 'Семейная',
    image: {
      light: programGuideImages.family.light,
      dark: programGuideImages.family.dark,
    },
    description: (
      <>
        <Body1 color="text-primary-default">
          {`Льготная программа для${NBSP}семей с${NBSP}детьми. Обычная ставка${NBSP}—${NBSP}6%, её${NBSP}может дополнительно снизить застройщик.`}
          <br />
          <br />
        </Body1>
        <Body1 color="text-primary-default">Подойдёт:</Body1>
        <ul className={styles.list}>
          <li>
            <Body1 color="text-primary-default">
              {`семьям с${NBSP}ребёнком, родившимся после${NBSP}1${NBSP}января 2018${NBSP}года`}
            </Body1>
          </li>
          <li>
            <Body1 color="text-primary-default">
              {`семьям с${NBSP}несовершеннолетним ребёнком с${NBSP}инвалидностью`}
            </Body1>
          </li>
          <li>
            <Body1 color="text-primary-default">
              {`семьям с${NBSP}двумя и${NBSP}больше несовершеннолетними детьми`}
            </Body1>
          </li>
        </ul>
        <Body1 color="text-primary-default">
          {`И${NBSP}дети, и${NBSP}заёмщик должны быть${NBSP}гражданами${NBSP}РФ.`}
        </Body1>
      </>
    ),
  },
  {
    title: 'ИТ-ипотека',
    image: {
      light: programGuideImages.it.light,
      dark: programGuideImages.it.dark,
    },
    description: (
      <>
        <Body1 color="text-primary-default">
          {`Льготная программа${NBSP}для${NBSP}тех, кто${NBSP}работает в${NBSP}ИТ-компаниях. Исключение${NBSP}— Москва и${NBSP}Санкт-Петербург: если вы сотрудник местной компании или${NBSP}хотите купить квартиру в${NBSP}столицах, программа не${NBSP}подойдёт.`}
          <br />
          <br />
        </Body1>
        <Body1 color="text-primary-default">{`Ставка${NBSP}— 6%. Есть требования по${NBSP}доходу:`}</Body1>
        <ul className={styles.list}>
          <li>
            <Body1 color="text-primary-default">
              {`от${NBSP}150${NBSP}000${NBSP}₽${NBSP}— для${NBSP}компаний из${NBSP}Московской и${NBSP}Ленинградской областей`}
            </Body1>
          </li>
          <li>
            <Body1 color="text-primary-default">
              {`от${NBSP}90${NBSP}000${NBSP}₽${NBSP}— для${NBSP}компаний из${NBSP}других регионов`}
            </Body1>
          </li>
        </ul>
      </>
    ),
  },
  {
    title: 'Базовая',
    image: {
      light: programGuideImages.base.light,
      dark: programGuideImages.base.dark,
    },
    description: (
      <Body1 color="text-primary-default">
        {`Кредит на${NBSP}недвижимость по${NBSP}рыночной ставке, который${NBSP}может${NBSP}взять любой гражданин РФ${NBSP}от${NBSP}18${NBSP}до${NBSP}75${NBSP}лет.`}
      </Body1>
    ),
  },
];
